import { render, staticRenderFns } from "./dualTemplate.vue?vue&type=template&id=727c54cc"
import script from "./dualTemplate.vue?vue&type=script&lang=js"
export * from "./dualTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports